export const twoDigits = (number: number): string => {
  return number > 9 ? String(number) : `0${number}`;
};
